import { formatMoney, formatPercent } from '../../utils/helpers/aiSpendFormat';

/** An inline stacked bar: share of a total, or a provider mix within a row. */
export default function CostShareBar({ segments, total }) {
  const sum = total || segments.reduce((acc, segment) => acc + (segment.value || 0), 0);
  if (!sum) return <span className="text-slate-400">—</span>;
  return (
    <span className="flex h-2 w-full min-w-[6rem] overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700">
      {segments.map((segment) => (
        <span
          key={segment.key}
          title={`${segment.label}: ${formatMoney(segment.value)} (${formatPercent(
            (segment.value || 0) / sum,
          )})`}
          style={{
            width: `${Math.max(((segment.value || 0) / sum) * 100, 0)}%`,
            backgroundColor: segment.color,
          }}
        />
      ))}
    </span>
  );
}
